import React from 'react';
import { Modal } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";

const initialValues = {
    subject: "",
    message: "",
};

const CreateTicketModal = ({ OrderDetailsModal, handleClose, onCreateTicketSubmit }) => {

    const createTicketSchema = Yup.object().shape({
        subject: Yup.string()
            .required("Subject is Required"),
        message: Yup.string()
            .required("Message is Required"),
    });

    const formik = useFormik({
        initialValues,
        validationSchema: createTicketSchema,
        onSubmit: (values) => {
            console.log(values)
            onCreateTicketSubmit(values);
        },
    });

    return (
        <Modal show={OrderDetailsModal} onHide={handleClose} centered className="def_modal">
            <Modal.Header closeButton>
                <Modal.Title className="fn_s_18 color_blk f-w-700">Create Ticket</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form className="form def_form frmwtpddng" onSubmit={formik.handleSubmit}>
                    <div className="form-group">
                        <label className="form-label">Subject</label>
                        <input
                            placeholder="Enter Subject"
                            type="text"
                            className={`form-control`}
                            name="subject"
                            {...formik.getFieldProps("subject")}
                        />
                        {formik.touched.subject && formik.errors.subject ? (
                            <div className="fv-plugins-message-container">
                                <div className="fv-help-block">{formik.errors.subject}</div>
                            </div>
                        ) : null}
                    </div>
                    <div className="form-group">
                        <label className="form-label">Message</label>
                        <textarea
                            className="form-control"
                            placeholder="Enter Message" rows="3"
                            name="message"
                            {...formik.getFieldProps("message")}
                        >
                        </textarea>
                        {formik.touched.message && formik.errors.message ? (
                            <div className="fv-plugins-message-container">
                                <div className="fv-help-block">{formik.errors.message}</div>
                            </div>
                        ) : null}
                    </div>

                    <div className="form-group d-flex flex-wrap justify-content-center align-items-center mb-0">
                        <button type="submit" className="btn btn-def btn-defv4">
                            <span>Submit</span>
                        </button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default CreateTicketModal;